export default function HowItWorksSection({
  title,
  steps,
  image,
  imageAlt = "",
  variant = "candidat",
}) {
  const isCandidat = variant === "candidat";

  return (
    <div className="container mx-auto max-w-4xl">
      {image && (
        <div className="flex justify-center mb-10">
          <img
            src={image}
            alt={imageAlt}
            className="w-full max-w-xs sm:max-w-sm lg:max-w-xs h-auto"
          />
        </div>
      )}
      <h2 className="text-2xl sm:text-3xl font-bold text-center mb-10 text-gray-900">
        {title}
      </h2>
      <div className="space-y-6">
        {steps.map((step, index) => (
          <div
            key={step.title}
            className="flex gap-4 sm:gap-6 items-start p-4 sm:p-6 rounded-xl bg-white shadow-sm border border-gray-100"
          >
            <div
              className={`flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center font-bold text-white ${
                isCandidat ? "bg-brand-primary" : "bg-brand-primaryDark"
              }`}
            >
              {index + 1}
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1">
                {step.title}
              </h3>
              <p className="text-gray-600 text-sm sm:text-base">
                {step.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
